import React from 'react';
import PropTypes from 'prop-types';
import ProgressiveIndicator from '@dtsl/icons/dist/icons/react/ProgressiveIndicator';
import { Loader } from '@dtsl/react/dist/components/Loader';
const InfiniteLoader = _ref => {
  let {
    hasMore = false,
    loading = false
  } = _ref;
  return hasMore ? /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      height: '2rem'
    }
  }, loading ? /*#__PURE__*/React.createElement(Loader, {
    indicator: /*#__PURE__*/React.createElement(ProgressiveIndicator, null)
  }) : null) : null;
};
InfiniteLoader.propTypes = {
  hasMore: PropTypes.bool,
  loading: PropTypes.bool
};
export default InfiniteLoader;